module.exports = __webpack_public_path__ + "img/c6.e943f6f4.png";